module.exports = __webpack_public_path__ + "static/media/cutoutT.da236561.svg";